import { connect } from "react-redux";

import App from "./App";
import { setAppIframed } from "./actions/index";

const mapStateToProps = state => ({
  userLoggedIn: state.userLoggedIn,
  user: state.user
});

const mapDispatchToProps = dispatch => ({
  setAppIframed: () => {
    dispatch(setAppIframed());
  }
});

const AppContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(App);

export default AppContainer;



// WEBPACK FOOTER //
// ./src/js/AppContainer.js